import { makeBridgeRequest } from 'common'
import Data from 'common/api'

import { useMutation } from '@tanstack/react-query'

export type GerarLinkRelatorioRequest = {
  trackNumber: string
  tipoSolicitacao: string
  dataSolicitacao: string
}

export const base: Data = {
  action: 'requestAPI',
  evtId: '',
  metadata: {
    endpoint: '',
    headers: {
      'x-inter-lgpd-origem': 'PF',
    },
    method: '',
    engine: 'CA',
  },
}

export const gerarLinkRelatorio = (requestParams: GerarLinkRelatorioRequest) => ({
  ...base,
  metadata: {
    ...base.metadata,
    endpoint: `/app-pf/central-privacidades/v1/solicitacao-dados/download-relatorio`,
    method: 'POST',
    body: requestParams,
  },
})

export async function generateReportBR(reportRequestData: GerarLinkRelatorioRequest) {
  return makeBridgeRequest(gerarLinkRelatorio(reportRequestData)).then((response) => response)
}

export const useGenerateReportBR = (reportData: GerarLinkRelatorioRequest) => {
  const {
    mutateAsync: fetchReport,
    data: report,
    isPending: isReportLoading,
    isError: isReportError,
  } = useMutation({
    mutationFn: () => generateReportBR(reportData),
  })

  return { fetchReport, report, isReportLoading, isReportError }
}
